module.exports = __webpack_public_path__ + "static/media/doorways.2a26e0df.jpg";